import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import { ModuleDoneType, ModuleType, PlanType } from "../../templates/types";

export const QuickstartRsvpTemplate: PlaniraTemplate = {
  planType: PlanType.Quickstart,
  type: PlanTemplateType.QuickstartRsvp,
  title: "Find attendees",
  description:
    "Find out who's attending and let your group easily share their responses.",
  longDescription: "",
  emoji: "👍",
  titleHelp: "Next After Work?, Birthday party?",
  image: require("../../assets/illustrations/Choose-pana.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "N/A",
          isDraggable: false,
          emoji: "👍",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Rsvp,
          doneType: ModuleDoneType.Voting,
          title: "Rsvp",
          emoji: "👍",
        },
      ],
    },
  ],
};
